import React, { useState } from 'react';
import { Link } from 'react-router-dom';
import { Menu, X, Instagram } from 'lucide-react';
import { brandInfo } from '../data/mock';

const Header = () => {
  const [isMenuOpen, setIsMenuOpen] = useState(false);

  const navLinks = [
    { name: 'Home', path: '#home' },
    { name: 'Gallery', path: '#gallery' },
    { name: 'Pricing', path: '#pricing' },
    { name: 'Contact', path: '#contact' }
  ];

  const scrollToSection = (e, path) => {
    e.preventDefault();
    const element = document.querySelector(path);
    if (element) {
      element.scrollIntoView({ behavior: 'smooth' });
      setIsMenuOpen(false);
    }
  };

  return (
    <header className="sticky top-0 z-50 bg-white border-b border-gray-200">
      <div className="container mx-auto px-4 lg:px-8">
        <div className="flex items-center justify-between h-20">
          {/* Logo */}
          <div className="flex items-center">
            <img 
              src={brandInfo.logo} 
              alt={brandInfo.name}
              className="h-12 w-auto"
            />
          </div>

          {/* Desktop Navigation */}
          <nav className="hidden md:flex items-center gap-8">
            {navLinks.map((link) => (
              <a
                key={link.name}
                href={link.path}
                onClick={(e) => scrollToSection(e, link.path)}
                className="nav-link text-black hover:text-gray-600 transition-colors"
              >
                {link.name}
              </a>
            ))}
            <a
              href={brandInfo.instagram}
              target="_blank"
              rel="noopener noreferrer"
              className="flex items-center gap-2 cta-button"
            >
              <Instagram size={16} />
              Follow
            </a>
          </nav>

          {/* Mobile Menu Button */}
          <button
            className="md:hidden p-2"
            onClick={() => setIsMenuOpen(!isMenuOpen)}
            aria-label="Toggle menu"
          >
            {isMenuOpen ? <X size={24} /> : <Menu size={24} />}
          </button>
        </div>

        {/* Mobile Navigation */}
        {isMenuOpen && (
          <nav className="md:hidden py-4 border-t border-gray-200">
            <div className="flex flex-col gap-4">
              {navLinks.map((link) => (
                <a
                  key={link.name}
                  href={link.path}
                  onClick={(e) => scrollToSection(e, link.path)}
                  className="nav-link text-black hover:text-gray-600 py-2"
                >
                  {link.name}
                </a>
              ))}
              <a
                href={brandInfo.instagram}
                target="_blank"
                rel="noopener noreferrer"
                className="flex items-center gap-2 cta-button w-fit"
              >
                <Instagram size={16} />
                Follow on Instagram
              </a>
            </div>
          </nav>
        )}
      </div>
    </header>
  );
};

export default Header;
